export const linksCategories = () => {
  return ['access_url', 'content_url', 'marketing_url', 'proxy_url', 'statistics_url', 'other_url', 'admin']
}
